export default () => ({
  trigger: {
    name: 'product_trade_in_overlay.click_on_complete',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        content: 'complete',
        sub_feature: null,
      },
    },
  },
});
